export type Invoice = {
  amount: number;
  createdAt: Date;
  invoiceNumber: string | null;
  receiptNumber: string | null;
  status: LegacyInvoiceFilterStatus | KeyholderInvoiceFilterStatus | null;
  stripeCustomerId: string | null;
  stripeInvoiceId: string;
  url?: string;
};

export enum LegacyInvoiceFilterStatus {
  Paid = 'paid',
  Declined = 'void',
  Open = 'open',
}

export enum KeyholderInvoiceFilterStatus {
  Paid = 'PAID',
  Unpaid = 'NOT PAID',
}

export type InvoiceSearchFilters = {
  status?: LegacyInvoiceFilterStatus | KeyholderInvoiceFilterStatus;
  createdAfter?: Date;
  createdBefore?: Date;
  getSubscriptionType: boolean;
};
